import React from 'react'
import styles from './List.module.css'
import { useSelector } from 'react-redux'
import Species from './Species'
import Spinner from './Spinner/Spinner'

const List = ({ setCurrentId }) => {

    const allSpecies = useSelector(state => state.posts)
    return (
        !allSpecies.length ? <Spinner /> :
        (
        <div className={styles.list}>
            {
                allSpecies.map((species) => (
                    <Species 
                        key={species._id}
                        species={species} 
                        setCurrentId={setCurrentId}
                    />
                ))
            }
        </div>)
    )
}

export default List
